import { Button } from '@salt/components';
import React, { useCallback, useState } from 'react';
import StepCategories from './create/StepCategories';
import { updateProject } from '../../api/users';

const EditCategoriesModal = ({ handleEditCategoriesModalClose, project, fetchData }) => {
  const [categories, setCategories] = useState(project.categories?.join(',') || '');

  const onSave = useCallback(() => {
    updateProject({
      projectId: project.id,
      categories: categories.split(',').map((c) => Number(c)),
    })
      .then(() => {
        fetchData();
      })
      .catch(() => {
        console.error('Failed to edit project categories');
      });
    handleEditCategoriesModalClose();
  }, [project, categories]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleEditCategoriesModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <StepCategories
          project={{ categories }}
          setProject={(proj) => setCategories(proj.categories)}
        />

        <div>
          <br />
          <Button
            onClick={handleEditCategoriesModalClose}
            type="neutral"
            className="max-w-[146px] h-[36px] ml-auto"
            paddingClassName="px-6"
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            type="positive"
            disabled={
              categories.split(',').every((num) => project.categories.includes(Number(num))) &&
              project.categories.every((num) => categories.split(',').includes(String(num)))
            }
            className="max-w-[146px] h-[36px] ml-auto float-right"
            paddingClassName="px-6"
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditCategoriesModal;
